import { useMemo } from 'react';

import { useAtom } from 'jotai';

import { CA_PROVINCES, COUNTRIES, US_STATES } from 'src/utils/countryList';

import { atomWithSessionStorage } from 'src/utils/atomWithSessionStorage';
import type { CheckoutFormState } from './components/Checkout.types';

export const checkoutFormInitial = {
  currentStep: 'DETAILS',
  hasAcceptedTerms: false,
} as CheckoutFormState;

export const checkoutFormAtom = atomWithSessionStorage(
  'checkoutForm',
  checkoutFormInitial
);
export const useCheckoutForm = () => useAtom(checkoutFormAtom);

export const useCheckoutFormLocationDetails = () => {
  const [checkoutFormState] = useCheckoutForm();

  const country = useMemo(() => {
    return COUNTRIES.find((c) => c.value === checkoutFormState.country);
  }, [checkoutFormState.country]);

  const state = useMemo(() => {
    if (checkoutFormState.country === 'US') {
      return US_STATES.find((s) => s.value === checkoutFormState.state)?.label;
    }

    return checkoutFormState.state;
  }, [checkoutFormState.state]);

  const province = useMemo(() => {
    if (checkoutFormState.country === 'CA') {
      return CA_PROVINCES.find((s) => s.value === checkoutFormState.province)
        ?.label;
    }
  }, [checkoutFormState.province]);

  return {
    country,
    state,
    province,
  };
};
